function CalendarManagement() {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-2">Calendar Management</h2>
      <p className="text-base-content/60">Terms, school days, and schedule templates.</p>
    </div>
  )
}

export default CalendarManagement
